<template>
  <v-alert v-if="!validMandatory" prominent type="warning" class="mb-2 px-4 py-2" outlined text>
    <v-row align="center">
      <v-col
        class="grow"
      >You must have at least one item from the category {{mandatoryInfo.category_desc}} to check out</v-col>
      <v-col class="shrink">
        <v-btn :to="{name:'OrdersSearch'}" color="warning" @click="loadMandatoryCat()">Load</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    isStandingOrder: null
  },
  computed: {
    validMandatory() {
      if (this.isStandingOrder) {
        if (this.$store.getters.retrieveStandingOrderTrolly) {
          return this.$store.getters.retrieveStandingOrderTrolly.mandatory_cat
            .valid;
        } else {
          return true;
        }
      } else {
        if (this.$store.getters.retrieveCurrentTrolly) {
          return this.$store.getters.retrieveCurrentTrolly.mandatory_cat.valid;
        }
        return true;
      }
    },
    mandatoryInfo() {
      if (this.isStandingOrder) {
        return this.$store.getters.retrieveStandingOrderTrolly.mandatory_cat;
      } else {
        return this.$store.getters.retrieveCurrentTrolly.mandatory_cat;
      }
    }
  },
  methods: {
    ...mapActions("orderSearch", ["getMandatoryCategory"]),
    // ...mapActions("standingOrderSearch", ["getMandatoryCategory"]),

    loadMandatoryCat() {
      // if(isStandingOrder){
      // }
      this.getMandatoryCategory();
    }
  }
};
</script>

<style lang="sass" scoped>
</style>